import { OktaAuth } from "@okta/okta-auth-js"
import { config } from "utils/configService"

export const oktaAuth = new OktaAuth(config.get("okta"))
